import Vue from "vue";
import Vuex from "vuex";
import queryStringify from "qs-stringify";
import axios from "axios";

Vue.use(Vuex);

async function downloadReport(url, filename) {
    try {
        const response = await axios.get(url, { responseType: "blob" });
        const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
        console.error(`Failed to download ${filename}:`, error);
        throw error;
    }
}

export default {
    name: "magic",
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async downloadMagicError(context, payload) {
            try {
                const orderNumber = payload.ordernumber;
                const range = context.getters.getGlobalDateRange;

                const queryParams = queryStringify({
                    ...payload,
                    from: range.From,
                    to: range.To
                });

                const url = `${magicApi}getReports?${queryParams}`;
                console.log(`Downloading file from: ${url}`);

                await downloadReport(url, `Order #${orderNumber} report.csv`);
                console.log("Report downloaded successfully.");
            } catch (error) {
                console.error("Error during report download:", error);
            }
        },

        async rerunMagicError(context) {
            try {
                let range = context.getters.getGlobalDateRange;
                let payload = {
                    from: `${range.From} 00:00:00`,
                    to: `${range.To} 23:59:59`
                };

                await axios.post(`${magicApi}utils/redoErrors`, payload);
            } catch (err) {
                errorHandler.tomcatError(err);
            }
        },

        async rerunMagicErrorForOrder(context, orderNumber) {
            try {
                await axios.get(`${magicApi}utils/redoErrors/${orderNumber}`);
            } catch (err) {
                errorHandler.tomcatError(err);
            }
        }
    }
};
